export const LOCALSTORAGE = {
    'shapes': 'gcd.shapes',
    'settings': 'gcd.settings',
    'images': 'gcd.images',
    'i18n': 'gcd.i18n',
    'fonts': 'gcd.fonts',
    'templateid': 'gcd.templateid',
    'changeshash': 'gcd.changeshash',
    'displaydata': 'gcd.displayData'
}

export const NOBG = {
    defaultBackendSettings:
    {
        type: "nobg",
        languages: ["en", "fi", "de", "et", "sv"],
        defaultlang: "en",
        endpoints: {
            // fontlist: "/designer/fonts/list",
            fontlist: "https://pdfmedia.givito.tech/static/default-fonts.json",
            // fontlistCustom: "https://pdfmedia.givito.tech/static/custom-fonts.json",
            exampletemplatelist: "https://pdfmedia.givito.tech/static/example-templates.json",
            templatelist: "https://pdfmedia.givito.tech/static/example-templates.json?list=1",
            // exampletemplatelist: "/designer/publictemplates/list",
            // templatelist: "/designer/templates/list",
            save: "/designer/templates/save/{id}",
            load: "/designer/templates/load/{id}",
            ping: "/designer/ping",
            render: "/designer/render/{lang}",
            dynamictext: "/designer/content/demo",
            login: "/login",
            site: "/",
            defaultpage: "/new-admin/designer",
            errorexit: "/",
        },
        features: {
            save: false,
            load: false,
            templatebrowser: false,
            publictemplatebrowser: true,
            rendererbrowser: true,
            dynamictexts: false,
        },
        display: {
            optionalfields: {
                options: [],
                overrides: {}
            }
        }

    }
}
// display: {
//     optionalfieldsmenu: {
//         enabled: false,
//         options: [
//             'voucherRestrictions',
//             'voucherTermsAndConditions',
//             'udf01'
//         ]
//     }
// }

export const UI = {
    paperSizeA4: [595, 842],
    imagesAccept: ".jpg,.jpeg,.png",
    imageSizeMiB: 1,
    imageMaxHeight: 3700,
    imageMaxWidth: 3700,
    basepath: '/designer/ui',
    backendSettingsUri: '/designer/settings',
    // service: '/gcd/service',
    // fonts: '/gcd/service',
    missingImageDataUrl: 'data:image/png;base64,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',
    qrPlaceholder: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHQAAAB0CAYAAABUmhYnAAACm0lEQVR4nO2YMY4DMQwD9/+fztXxFQ5ByfISM8BWm5CSx0WQ5wNRPNMDQC0IDQOhYSA0DISGgdAwEBoGQsNAaBgIDQOhYSA0DISGgdAwEBqGLfR5nqPPrt+d77b9ZB92AEIRilCEIvRXH3ZA8UBqvivE7XdBqPkeoYcHUvMRuuTdNpCaj9Alr3sg90eBK8A9sNv2285rB1y2MELdgMsWRqgbcNnCCHUDhhdW86f71XwVhCJUG+i2A53uV/NVEIpQbaDTC6v5b9tvO68dcNnCCHUDLlsYoW7AZQsj1A0oHuh0/nQ/Qg/ztv0QOtyP0MO8bb9yod3Prr/7/en9ZB92AEIRilCEIvRXH3bCMNUH8nZefwII/eb1J4DQb15/Agj9ZvzPefXzpwWqfdXnIc9rByBU+jxCEarNawcgVPr864SOL9R8gaovHEIPz4NQhCIUoRcJlQvNhasvTPcFrL4A2z47QS1EKEIR+jsIRahZ2HxA7jxuf/cF2c5nJ6iFCEVo5fd3eW4/QhF6l1B1ATe/+unuV/NcENrcr+a5ILS5X81zQWhzv5rncvxHUTXdB3j6wrogtDi/en45z04YBqFLnp0wDEKXPDvA/NGgPrt+9X31vtMgtHjfaRBavO80CC3ed5r2Pxa689V+9wK5+d0gFKFLAEKl/G4QitAlQDxwdeHqA+6me59tvx2AUKkPoQjV+u0AhEp9CD38vv3AEYpQKd8OQKgEQhGq5dsBlwl1H7VfnacbhCJ0CUCoNE83CEXoEtA8cPWBuhfEna/6+//y7ACEIrQzH6FuAEKzhXY/u/7p+dT5q0EoQpcAhCIUoX30N8BREBoGQsNAaBgIDQOhYSA0DISGgdAwEBoGQsNAaBgIDQOhYSA0DISG8Qe+/kHqco7khgAAAABJRU5ErkJggg==',
}
//   missingImageDataUrlRed:'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAAEklEQVQYlWN4yKHxHx9mGBkKAAXEhAEljMmDAAAAAElFTkSuQmCC',

export const ZIPFILENAMES = {
    currentVersion: { version: "1.0.0" },
    templateVersion: '_version.json',
    template: "template.json",
    settings: "editorSettings.json",
    i18n: "i18n.json",
    images: "assets/images/",
    fonts: "assets/fonts/",
    importAccept: ".zip,.gcdtemplate",
    defaultFileExtension: ".gcdtemplate",
    defaultFileName: "exported-template.gcdtemplate",
}

export const MANDATORYFIELDS = {
    voucherTitle: false,
    voucherText: false,
    validityStartDate: false,
    expirationDate: false,
    refNumber: false,
    customerMessage: false,
    valueText: false,
}

export const DYNAMICFIELDDEFAULTTEXT = {
    'default': {
        voucherTitle: 'Lorem ipsum dolor sit amet!',
        voucherText: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus ut augue justo. Pellentesque tempor suscipit urna.',
        validityStartDate: '01.03.202X',
        expirationDate: '01.03.202Y',
        refNumber: '12345678-0123456',
        customerMessage: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus ut augue justo. Pellentesque tempor suscipit urna. Vivamus urna dui, sodales et ante sed, efficitur maximus felis.',
        valueText: 'X15 €',
        voucherTermsAndConditions: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus ut augue justo. Pellentesque tempor suscipit urna. Vivamus urna dui, sodales et ante sed, efficitur maximus felis.',
        voucherRestrictions: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus ut augue justo. Pellentesque tempor suscipit urna. Vivamus urna dui, sodales et ante sed, efficitur maximus felis.',
        udf01: 'Lorem ipsum dolor sit amet!',
        udf02: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus ut augue justo. Pellentesque tempor suscipit urna. Vivamus urna dui, sodales et ante sed, efficitur maximus felis.',
        udf03: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus ut augue justo. Pellentesque tempor suscipit urna. Vivamus urna dui, sodales et ante sed, efficitur maximus felis.',
        udf04: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus ut augue justo. Pellentesque tempor suscipit urna. Vivamus urna dui, sodales et ante sed, efficitur maximus felis.',
        udf05: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus ut augue justo. Pellentesque tempor suscipit urna. Vivamus urna dui, sodales et ante sed, efficitur maximus felis.',

    }
}


export default {
    LOCALSTORAGE: LOCALSTORAGE,
    MANDATORYFIELDS: MANDATORYFIELDS,
    ZIPFILENAMES: ZIPFILENAMES,
    DYNAMICFIELDDEFAULTTEXT: DYNAMICFIELDDEFAULTTEXT,
    NOBG: NOBG
}

